<template>
    <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
                <h4 class="title">{{ this.merchant.id ? 'Edit' : 'Create' }} Merchant</h4>
            </div>
        </md-card-header>
        <md-dialog id="importDialog" :md-active.sync="showImportPopup" @md-opened="getMerchants" @md-clicked-outside="closeImportPopup">
            <md-dialog-title>Import Menu</md-dialog-title>
            <div id="importLayout" class="md-layout">
                <div class="md-layout-item md-size-60">
                    <h3>FROM</h3>
                    <md-field>
                        <md-select v-model="importMerchantId">
                            <md-option v-for="item in merchants" :key="item.id" :value="item.id">
                                {{ getImportName(item) }}
                            </md-option>
                        </md-select>
                    </md-field>
                </div>
                <div class="md-layout-item md-size-40">
                    <h3>TO</h3>
                    <strong>{{ this.merchant.name }}</strong>
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-black" @click="closeImportPopup">Close</md-button>
                <md-button class="md-primary" @click="importMenu">IMPORT - CAN'T BE UNDONE</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog id="mercuryDialog" :md-active.sync="showMercuryDialog" @md-opened="getMercuryNames" @md-clicked-outside="closeMercuryPopup">
            <md-dialog-title>Link Mercury</md-dialog-title>
            <div id="importLayout" class="md-layout">
                <h3 v-if="mercuryAccounts.length == 0">Loading...</h3>
                <div v-else class="md-layout-item">
                    <md-field>
                        <md-select v-model="mercuryAccountId">
                            <md-option v-for="item in mercuryAccounts" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </md-option>
                        </md-select>
                    </md-field>
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-black" @click="closeMercuryPopup">Close</md-button>
                <md-button class="md-primary" @click="updateMercuryInfo">Update</md-button>
            </md-dialog-actions>
        </md-dialog>
        <form class="form-horizontal" enctype="multipart/form-data" action="" method="post" v-on:submit.prevent="onSubmit">
            <div class="md-layout">
                <div class="md-layout-item md-size-50 md-small-size-100">
                    <div class="md-layout-item">
                        <md-field>
                            <label>Name</label>
                            <md-input v-model="merchant.name"
                                      type="text"
                                      required></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <md-field>
                            <label>NetSuite ID</label>
                            <md-input v-model="merchant.ns_location_netsuite_entity_id"
                                      type="text"
                                      required
                                      disabled ></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <md-field>
                            <label>Permanent Address</label>
                            <md-input v-model="merchant.ns_location_primary_address"
                                      type="text"
                                      required
                                      disabled ></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <md-field>
                            <label>Current Address</label>
                            <md-input v-model="merchant.street_address" :disabled="isDisabled"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <md-field>
                                <label>Current Full Address</label>
                                <vue-google-autocomplete
                                        ref="full_address"
                                        id="map"
                                        v-model="merchant.full_address"
                                        classname="form-control"
                                        placeholder="Please type your address"
                                        v-on:placechanged="getAddressData"
                                        types=""
                                        country="us"
                                        autocomplete="off">
                                </vue-google-autocomplete>
                            </md-field>
                        </div>
                    </div>
                    <div class="md-layout-item">
                        <md-field>
                            <label>App Display Address</label>
                            <md-input v-model="merchant.display_address" type="text" />
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <VuePhoneNumberInput v-model="phone" default-country-code="US" :no-country-selector="true"
                        @update="onPhoneChange" />
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <md-field>
                                <label>Pickup Text</label>
                                <md-input v-model="merchant.pickup_text" type="text"></md-input>
                            </md-field>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <md-field>
                                <label>Latitude</label>
                                <md-input v-model="merchant.latitude" :disabled="isDisabled" type="number">
                                </md-input>
                            </md-field>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <md-field>
                                <label>Longitude</label>
                                <md-input v-model="merchant.longitude" :disabled="isDisabled" type="number">
                                </md-input>
                            </md-field>
                        </div>
                    </div>
                    <div class="md-layout-item">
                        <md-field>
                            <label>Timezone</label>
                            <md-select v-model="merchant.timezone" name="time" required disabled>
                                <md-option value="America/New_York">America/New York</md-option>
                                <md-option value="America/Chicago">America/Chicago</md-option>
                                <md-option value="America/Denver">America/Denver</md-option>
                                <md-option value="America/Phoenix">America/Phoenix</md-option>
                                <md-option value="America/Los_Angeles">America/Los Angeles</md-option>
                                <md-option value="America/Anchorage">America/Anchorage</md-option>
                                <md-option value="America/Adak">America/Adak</md-option>
                                <md-option value="Pacific/Honolulu">Pacific/Honolulu</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <md-field>
                            <label>Tax Rate</label>
                            <md-input v-model="merchant.tax_rate" type="text" @keypress="onlyNumber" ></md-input>
                            <strong>%</strong>
                        </md-field>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-50 md-small-size-100">
                            <md-field>
                                <label>Outstanding Balance</label>
                                <span class="md-prefix">$</span>
                                <md-input v-model="merchant.outstanding_balance_cents" type="text" @keypress="onlyNumber" />
                            </md-field>
                        </div>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <h4 id="pricingPromoHeader" class="card-title display-inline">Pricing Promos</h4>
                        <md-button id="pricingPromoAddBtn" class="md-icon-button md-dense md-black" @click="addPromo">
                          <md-icon>add_circle_outline</md-icon>
                        </md-button>
                        <md-content class="md-scrollbar pricing-scroll-layout">
                            <pricing-promo-card
                                v-for="promo in merchant.pricing_promos"
                                :promoInfo="promo"
                                :key="promo.id"
                                @toggleDelete="toggleDeletePromo"
                            />
                        </md-content>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <h4 id="pricingTierHeader" class="card-title display-inline">Pricing Tiers</h4>
                        <md-button id="pricingTierAddBtn" class="md-icon-button md-dense md-black" @click="addTier">
                          <md-icon>add_circle_outline</md-icon>
                        </md-button>
                        <md-content class="md-scrollbar pricing-scroll-layout">
                            <pricing-tier-card
                                v-for="(tier, index) in merchant.pricing_tiers"
                                :tierInfo="tier"
                                :allowDelete="index !== 0"
                                :key="tier.id"
                                @toggleDelete="toggleDeleteTier"
                            />
                        </md-content>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                        <h4 class="card-title">Switches</h4>
                        <md-switch v-model="merchant.active">Active</md-switch>
                        <md-switch v-model="merchant.rewards_enabled">Rewards Enabled</md-switch>
                    </div>

                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                    <div class="md-layout-item md-size-30 md-xsmall-size-100">
                        <h4 class="card-title">Logo</h4>
                        <div class="file-input">

                            <div v-if="!image_preview">
                                <div class="image-container">
                                    <img :src="regularImg" title=""/>
                                </div>
                            </div>
                            <div class="image-container" v-else>
                                <img :src="image_preview"/>
                            </div>

                            <div class="button-container">
                                <md-button
                                        class="md-danger md-round"
                                        @click="removeImage"
                                        v-if="image_preview"
                                ><i class="fa fa-times"></i>Remove</md-button>
                                <md-button class="md-success md-round md-fileinput">
                                    <template v-if="!image_preview">Select image</template>
                                    <template v-else>Change</template>
                                    <input type="file" accept="image/*" @change="onFileChange($event)"/>
                                </md-button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="md-layout-item">
                        <h4 class="card-title">Cover Photos</h4>
                        <div class="file-input" style="margin-bottom: 24px;" v-for="(cover_photo_url, index) in merchant.cover_photo_urls" :key="index">
                            <div class="image-container">
                              <img :src="cover_photo_url"/>
                            </div>

                            <div class="button-container">
                              <md-button
                                class="md-danger md-round"
                                @click="removeCoverPhoto(cover_photo_url)"
                              >
                                <i class="fa fa-times"></i>
                                Remove
                              </md-button>
                            </div>
                        </div>
                        <br>
                        <div class="file-input">
                            <div class="image-container">
                              <img :src="regularImg" title=""/>
                            </div>

                            <div class="button-container">
                              <md-button class="md-success md-round md-fileinput">
                                <template>Select image</template>
                                <input type="file" accept="image/*" @change="onCoverPhotoFileChange($event)"/>
                              </md-button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="md-layout-item md-size-30 md-xsmall-size-100">
                        <h4 class="card-title">Bank Info</h4>
                        <md-button v-if="merchant.has_plaid" class="md-danger" @click="showDeleteBankPopup">Delete Bank Account</md-button>
                        <md-button v-else class="md-danger" disabled>Not Connected</md-button>
                        <md-button class="md-black" @click="showMercuryDialog = true"> {{ mercuryBoxTitle }}</md-button>
                    </div>
                    <br>
                    <div class="md-layout-item md-size-30 md-xsmall-size-100">
                        <h4 class="card-title">Menu Import</h4>
                        <md-button id="importMenuBtn" class="md-black" v-show="this.merchant.id != null" @click="showImportPopup = true">Import Menu</md-button>
                    </div>
                </div>
                <md-card-actions md-alignment="left">
                    <md-button class="md-success" type="submit"> SAVE </md-button>
                </md-card-actions>
            </div>
        </form>

        <md-snackbar md-position="center" :md-duration="1500" :md-active.sync="barMessage" md-persistent>
          <span> {{ barMessage }} </span>
        </md-snackbar>

    </md-card>
</template>

<script>
import { join } from 'lodash';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import axios from 'axios';
import { SlideYDownTransition } from "vue2-transitions";
import { showConfirmationDialog } from '@/components/ActionConfirm';
import PricingPromoCard from "@/components/Cards/PricingPromoCard.vue"
import PricingTierCard from "@/components/Cards/PricingTierCard.vue"
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import Swal from "sweetalert2";
import moment from "moment"

export default {
    components: {
        VueGoogleAutocomplete,
        SlideYDownTransition,
        PricingPromoCard,
        PricingTierCard,
        VuePhoneNumberInput
    },
    name: "EditMerchant",
    props: {
        regularImg: {
            type: String,
            default: "./img/image_placeholder.jpg"
        }
    },
    data(){
        return {
            cloudinary: {
                uploadPreset: 'merchant_logo',
                apiKey: '662823711412329',
                cloudName: 'cloosiv'
            },
            loadingImage: false,
            imageRegular: "",
            imageCircle: "",
            merchant: {
                tax_rate: 0.0,
                rewards_enabled: true,
                timezone: "America/New_York",
                pricing_tiers: []
            },
            image_preview: "",
            isDisabled: true,
            showImportPopup: false,
            merchants: null,
            importMerchantId: null,
            barMessage: null,
            mercuryAccountId: null,
            mercuryAccounts: [],
            showMercuryDialog: false,
            phone: null
        }
    },

    computed: {
        clUrl: function() {
            return `https://api.cloudinary.com/v1_1/${this.cloudinary.cloudName}/upload`
        },
        mercuryBoxTitle: function() {
            return (this.merchant.merc_recipient_id == null ? "Link Mercury - No Account" : "Update Mercury - Linked")
        }
    },
    methods: {
        createImage(file) {
            let reader = new FileReader();
            reader.onload = event => {
                this.image_preview = event.target.result;
            };
            reader.readAsDataURL(file);
        },
        removeImage: function() {
            this.image_preview = "";
            this.merchant.logo_image = "";
        },
        removeCoverPhoto: function(url) {
            this.merchant.cover_photo_urls = this.merchant.cover_photo_urls.filter(photo_url =>
              photo_url !== url
            );
        },
        onFileChange(event) {
            let files = event.target.files || event.dataTransfer.files;
            if (!files.length) return;

            if (event.target.name) {
                this.createImage(files[0]);
            } else {
                this.createImage(files[0]);
            }

            const formData = new FormData();
            formData.append('file', files[0]);
            formData.append('upload_preset', this.cloudinary.uploadPreset);

            this.loadingImage = true;
            axios
                .create({withCredentials: false})
                .post(this.clUrl, formData).then(response => {
                this.loadingImage = false;
                this.merchant.logo_url = response.data.secure_url;
            })

        },
        onCoverPhotoFileChange(event) {
            let files = event.target.files || event.dataTransfer.files;
            if (!files.length) return;

            const formData = new FormData();
            formData.append('file', files[0]);
            formData.append('upload_preset', this.cloudinary.uploadPreset);

            this.loadingImage = true;
            axios
                .create({withCredentials: false})
                .post(this.clUrl, formData).then(response => {
                this.loadingImage = false;
                this.merchant.cover_photo_urls.push(response.data.secure_url);
            })

        },
        onSubmit() {
            const merchant =  {...this.merchant};
            merchant.outstanding_balance_cents = (merchant.outstanding_balance_cents * 100)
            merchant.pricing_tiers_attributes = merchant.pricing_tiers
            merchant.pricing_promos_attributes = merchant.pricing_promos.map((p) => {
                const date_min = this.formatDate(p.date_min)
                const date_max = this.formatDate(p.date_max)
                return { ...p, date_min, date_max }
            })

            const config = {header: {'Content-Type': 'multipart/form-data'}};
            const successHandler = () => this.$router.push('/merchants');
            if (this.merchant.id) {
                if (merchant.display_address.trim().length == 0) {
                    merchant.display_address = this.merchant.street_address
                }

                this.$http.secured.put(`/v1/merchants/${this.merchant.id}`, {merchant}, config)
                .then(successHandler)
                .catch(error => {
                    const data = error.response.data
                    const keys = Object.keys(data)
                    const msg = keys.map(k => k + " " + data[k]).join("\n")
                    alert(msg)
                })
            }
            else {
                this.$http.secured.post(`/v1/merchants`, {merchant}, config).then(successHandler);
            }
        },
        getAddressData: function (addressData, placeResultData) {
            this.full_address = addressData;
            this.merchant.street_address = `${addressData.street_number} ${addressData.route}`
            this.merchant.display_address = this.merchant.street_address
            this.merchant.longitude = addressData.longitude
            this.merchant.latitude = addressData.latitude

            var number = placeResultData["international_phone_number"]
            if (number) {
                this.phone = number
                this.merchant.phone = number.replace(/[ -]/g, '')
            }

            this.merchant.full_address = `${this.merchant.street_address}, ${addressData.locality}, ${addressData.administrative_area_level_1} ${addressData.postal_code}`
            this.$forceUpdate()
            this.$nextTick(() => {
                this.$refs.full_address.update(this.merchant.full_address)
            })
        },
        onPhoneChange(data) {
            this.merchant.phone = data.e164
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault();
            }
        },
        closeImportPopup() {
            this.showImportPopup = false
        },
        getMerchants() {
            if (this.merchants == null) {
                this.$http.secured.get(`/v1/merchants/import-merchant-list`)
                .then(response => {
                    this.merchants = response.data
                })
                .catch(error => alert(error))
            }
        },
        getImportName(merchant) {
            var address = merchant.street_address
            if (address == null) {
                address = "No Address"
            }

            return (merchant.name + " - " + address)
        },
        importMenu() {
            this.$http.secured.post(`/v1/merchants/import-menu`, {'from': this.importMerchantId, 'to': this.merchant.id})
            .then(response => {
                this.closeImportPopup()
            })
            .catch(error => alert(error))
        },
        showMarkedForDeletion(text) {
            Swal.fire({
                title: "Marked for deletion",
                text: text,
                confirmButtonClass: "md-button md-success",
                confirmButtonText: "OK",
                buttonsStyling: false
            })
        },
        addPromo() {
            const pricing_promo = { name: "standard_trial", date_min: null, date_max: null, percent: 3.0 }
            this.merchant.pricing_promos.push(pricing_promo)
        },
        toggleDeletePromo(pricing_promo) {
            if (pricing_promo.id) {
                if (pricing_promo["_destroy"]) {
                    // Promo was previously marked for deletion. Unmark it.
                    pricing_promo["_destroy"] = null
                } else {
                    pricing_promo["_destroy"] = true
                    this.showMarkedForDeletion("Saving the merchant will delete this promo")
                }
            }
            else {
                this.merchant.pricing_promos.splice(this.merchant.pricing_promos.indexOf(pricing_promo), 1)
            }
        },
        addTier() {
            var nextTier = 0
            var lastMax = 0
            for (var price_tier of this.merchant.pricing_tiers) {
                if (price_tier.tier > nextTier) {
                    nextTier = price_tier.tier
                }

                if (price_tier.max > lastMax) {
                    lastMax = price_tier.max
                }
            }

            var newPriceTier = { tier: (nextTier + 1), min: (lastMax + 1), max: (lastMax + 10000), percent: 5.0 }
            this.merchant.pricing_tiers.push(newPriceTier)
        },
        toggleDeleteTier(pricing_tier) {
            if (pricing_tier.id) {
                if (pricing_tier["_destroy"]) {
                    // Tier was previously marked for deletion. Unmark it.
                    pricing_tier["_destroy"] = null
                } else {
                    pricing_tier["_destroy"] = true
                    this.showMarkedForDeletion("Saving the merchant will delete this tier")
                }
            }
            else {
                this.merchant.pricing_tiers.splice(this.merchant.pricing_tiers.indexOf(pricing_tier), 1)
            }
        },
        showDeleteBankPopup() {
            showConfirmationDialog(() => this.deleteBank())
        },
        deleteBank() {
            this.$http.secured.post(`/v1/merchants/delete-bank/`, { id: this.merchant.id })
            .then(response => {
                this.merchant.has_plaid = false
            })
            .catch(error => alert(error))
        },
        getMercuryNames() {
            if (this.mercuryAccounts.length > 0) {
                return
            }

            this.$http.secured.get(`/v1/merchants/mercury-list`)
            .then(response => {
                var sortedAccounts = response.data.recipients.sort((a, b) => { return a.name.localeCompare(b.name) })
                this.mercuryAccounts = sortedAccounts
            })
            .catch(error => alert(error))
        },
        updateMercuryInfo() {
            this.$http.secured.put(`/v1/merchants/${this.merchant.id}`, { merc_recipient_id: this.mercuryAccountId })
            .then(response => {
                this.merchant.merc_recipient_id = this.mercuryAccountId
                this.barMessage = `Mercury account successfully updated`
                this.closeMercuryPopup()
            })
            .catch(error => alert(error))
        },
        closeMercuryPopup() {
            this.showMercuryDialog = false
        },
        formatDate(date) {
            return date ? moment(date).format('YYYY-MM-DD') : null
        }
    },
    created() {
        if (this.$route.params.id) {
            this.$http
                .secured
                .get(`/v1/merchants/${this.$route.params.id}`)
                .then(response => {
                    this.image_preview = response.data.logo_url;
                    this.merchant = response.data;
                    this.merchant.outstanding_balance_cents = (this.merchant.outstanding_balance_cents * 0.01).toFixed(2)
                    this.merchant.pricing_promos = this.merchant.pricing_promos.map((x) => ({ _destroy: null, ...x }))
                    this.merchant.pricing_tiers = this.merchant.pricing_tiers.map((x) => ({ _destroy: null, ...x }))
                    this.mercuryAccountId = response.data.merc_recipient_id // Making this its own field to not sync the recipient_id on the merchant object
                    this.phone = this.merchant.phone
                })
                .catch(error => alert(error))
        }
    },
    mounted() {
        this.$refs.full_address.focus();
    }
}

</script>

<style lang="scss">
    #map {
        height: 50px;
        margin-top: 30px;
    }
    #importMenuBtn {
        margin: 40px;
    }
    #importDialog {
        width: 40vw;
    }
    #importLayout {
        padding-top: 25px;
        padding-bottom: 50px;
        padding-left: 15px;
        padding-right: 15px;
    }
    .md-menu-content.md-select-menu {
        max-width: 400px;
    }
    .pricing-scroll-layout {
        white-space: nowrap;
        overflow: auto;
        padding: 10px;
    }
    .display-inline {
        display: inline-block;
    }
    #pricingPromoAddBtn {
        margin-top: 22px;
        margin-left: 10px;
    }
    #pricingTierAddBtn {
        margin-top: 22px;
        margin-left: 10px;
    }
</style>
